import React from "react";
import { CssBaseline } from "@mui/material";

const App: React.FC = () => {
  return (
    <>
      <CssBaseline />
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          width: '100vw',
          margin: 0,
          padding: 0,
          backgroundColor: '#ffffff',
          overflow: 'hidden'
        }}
      >
        <img
          src={`../../assets/icargo.png`}
          alt="icargo"
          style={{
            maxWidth: '100%',
            maxHeight: '100vh',
            width: 'auto',
            height: 'auto',
            objectFit: 'contain'
          }}
        />
      </div>
    </>
  );
};

export default App; 